export default __webpack_public_path__ + "static/chillenium-e770aaae9b3fd35bb4b2d0b32cfad174.png";